import apiService from './api';
import { ApiResponse } from '../types';

/**
 * O maior km que o painel de um veiculo ja registrou no sistema, e de onde
 * veio (cadastro, abastecimento, manutencao ou viagem).
 *
 * As telas oferecem esse valor preenchido no campo de km e recusam qualquer
 * coisa menor — o servidor recusa tambem. O hodometro so anda para frente;
 * um km menor e erro de digitacao, e entrava calado.
 */
export interface UltimoKm {
  km: number;
  origem: string;
  data: string | null;
  /** Frase pronta: "103.432 km (abastecimento em 14/09/2026)". */
  descricao: string;
}

export const ultimoKmService = {
  /** Area de gestao. */
  doVeiculo: async (veiculoId: number): Promise<UltimoKm | null> => {
    const resposta = await apiService.get<ApiResponse<UltimoKm | null>>(`/v1/veiculos/${veiculoId}/ultimo-km`);
    return resposta.data ?? null;
  },

  /** Portal do motorista: so os veiculos atribuidos a ele. */
  doVeiculoNoPortal: async (veiculoId: number): Promise<UltimoKm | null> => {
    const resposta = await apiService.get<ApiResponse<UltimoKm | null>>(`/portal/veiculos/${veiculoId}/ultimo-km`);
    return resposta.data ?? null;
  },
};
